export default __webpack_public_path__ + "static/media/IMG_5390.92844ee9.JPG";